export default __webpack_public_path__ + "static/media/Player_Plus_Img_48px.99b1e75c.svg";